var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"enter-viewport",rawName:"v-enter-viewport"}],ref:"rootRef",staticClass:"clip o-h",on:{"enterViewport":_vm.animateIn}},[_c('WebP',{attrs:{"picture":_vm.picture,"sets":_vm.sets,"className":_vm.className}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }